import { useMemo, useState } from "react";
import { useDashboard, useRefresh } from "../lib/api";
import { Loading, PageHeader } from "../components/PageHeader";
import { StockRow } from "../components/StockRow";
import { AddProductDialog } from "../components/AddProductDialog";
import { Chips, SearchBox } from "../components/Filters";

const HEAD = ["Product", "SAP item", "Units / pallet", "SAP stock", "Our stock holding", "Source", "Stock used", "Weekly demand", "DOH", "Weeks cover", "Status", "Unit cost £", "Stock value", "Capacity M1 / M2 / M3", ""];

export default function StockHolding() {
  const { data, isLoading } = useDashboard();
  const refresh = useRefresh();
  const [q, setQ] = useState("");
  const [country, setCountry] = useState("ALL");
  const [view, setView] = useState("ALL");
  const countries = useMemo(() => ["ALL", ...new Set((data?.products || []).map((p) => p.country))], [data]);
  if (isLoading || !data) return <Loading />;
  const list = data.products.filter((p) => {
    const text = `${p.code} ${p.friendly_name} ${p.sap_code} ${p.description}`.toLowerCase();
    if (q && !text.includes(q.toLowerCase())) return false;
    if (country !== "ALL" && p.country !== country) return false;
    if (view === "OVERRIDE" && p.source !== "override") return false;
    if (view === "LOW" && p.status !== "low") return false;
    return true;
  });
  return (
    <div data-testid="stock-page">
      <PageHeader kicker="Our stock vs SAP upload" title="Stock Holding">
        <AddProductDialog onSaved={refresh} />
      </PageHeader>
      <p className="rise mb-6 max-w-3xl text-sm leading-relaxed text-slate-400">
        Type your own stock holding to replace the SAP figure. It stays in place through new SAP uploads until you clear it with the
        <span className="mx-1 text-amber-400">×</span>button. Days on hand, weeks of cover, value and the per-FC Amazon figures recalculate straight away.
      </p>
      <div className="mb-4 flex flex-wrap items-center gap-3">
        <SearchBox value={q} onChange={setQ} testId="stock-search" placeholder="Search item, SAP code…" />
        <Chips options={countries} value={country} onChange={setCountry} testPrefix="stock-country" />
        <Chips options={["ALL", "OVERRIDE", "LOW"]} value={view} onChange={setView} testPrefix="stock-view" />
      </div>
      <div className="overflow-x-auto rounded-lg border border-slate-800 bg-slate-900/60 shadow-xl">
        <table className="data-table w-full text-sm" data-testid="stock-table">
          <thead><tr>{HEAD.map((h) => <th key={h}>{h}</th>)}</tr></thead>
          <tbody>
            {list.map((p) => <StockRow key={p.code} p={p} target={data.kpis.target_doh} onSaved={refresh} />)}
          </tbody>
        </table>
        {list.length === 0 && <div data-testid="stock-empty" className="p-8 text-sm text-slate-500">No products match these filters.</div>}
      </div>
    </div>
  );
}
